import { Link } from "react-router-dom";
// ⚠️ Best-guess hook name — verify against generated v1.ts (Rule MKT-FE-05).
import { useV1MarketplaceOrdersList } from "@/api/generated/v1/v1";
import type { OrderExchange } from "@/api/generated/models";
import { OrderStatusBadge } from "../components/OrderStatusBadge";
import { PageBanner } from "@/shared/components/PageBanner";

export function OrderListPage() {
  const { data, isLoading, isError } = useV1MarketplaceOrdersList();
  const orders = data?.results ?? [];

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="سفارش‌ها"
        subtitle="مدیریت و پیگیری سفارش‌های ثبت‌شده در بازار"
        icon="📦"
        helpLink="/help/marketplace/orders"
      />

      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>
        {isLoading && <p>در حال بارگذاری...</p>}
        {isError && <p style={{ color: "red" }}>خطا در دریافت سفارش‌ها.</p>}

        {!isLoading && !isError && (
          <div className="table-container" style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", textAlign: "right", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid var(--glass-border)" }}>
                  <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>شناسه</th>
                  <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>مقدار</th>
                  <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>وضعیت</th>
                </tr>
              </thead>
              <tbody>
                {orders.length === 0 && (
                  <tr>
                    <td colSpan={3} style={{ padding: "2rem", textAlign: "center", color: "var(--color-text-muted)" }}>
                      هیچ سفارشی یافت نشد.
                    </td>
                  </tr>
                )}
                {orders.map((o: OrderExchange) => (
                  <tr key={o.id} style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                    <td style={{ padding: "1rem" }}>
                      <Link to={`/marketplace/orders/${o.id}`} style={{ fontWeight: "bold", textDecoration: "none", color: "var(--color-primary-light)" }}>{o.id}</Link>
                    </td>
                    <td style={{ padding: "1rem", fontWeight: "bold" }}>{o.quantity}</td>
                    <td style={{ padding: "1rem" }}>
                      <OrderStatusBadge status={o.status} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
